import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconLink = ({
  title = "Link",
  color = "black",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="Link" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M9.59205,17.280975 L8.68125,18.185475 C7.891725,18.968025 6.60765,18.9687 5.818575,18.185475 C5.439225,17.80905 5.230875,17.3091 5.230875,16.77765 C5.230875,16.2462 5.43945,15.746025 5.81835,15.3696 L9.17085,12.043425 C9.86565,11.354475 11.172675,10.33995 12.125325,11.284725 C12.5625,11.718975 13.26855,11.71605 13.702575,11.2791 C14.136825,10.84215 14.134125,10.135875 13.69695,9.702075 C12.077625,8.095125 9.6843,8.392125 7.5999,10.460325 L4.247175,13.786725 C3.4428,14.58525 3,15.64725 3,16.77765 C3,17.90805 3.4428,18.969825 4.2474,19.76835 C5.075175,20.5896 6.16215,21 7.249575,21 C8.337225,21 9.42465,20.5896 10.252875,19.7679 L11.16435,18.863175 C11.6013,18.429375 11.603775,17.723325 11.169525,17.28615 C10.73595,16.849425 10.029225,16.84695 9.59205,17.280975 Z"
        fill={uiColorToBaseColor(color)}
      />
      <path
        d="M19.75215,4.3599 C18.0129,2.63415 15.5811,2.54055 13.971,4.13805 L12.83565,5.265075 C12.398475,5.6991 12.395775,6.404925 12.830025,6.8421 C13.264275,7.279275 13.970325,7.28175 14.4075,6.847725 L15.5424,5.721375 C16.376475,4.89315 17.468625,5.2365 18.180975,5.943225 C18.560775,6.31965 18.76935,6.819825 18.76935,7.351275 C18.76935,7.88295 18.56055,8.383125 18.181425,8.75955 L14.6046,12.3078 C12.969075,13.9305 12.201825,13.168875 11.87445,12.843975 C11.437275,12.40995 10.73145,12.41265 10.2972,12.8496 C9.86295,13.28655 9.86565,13.992825 10.302825,14.426625 C11.05365,15.171825 11.910675,15.541275 12.8091,15.541275 C13.909125,15.541275 15.071025,14.987325 16.175775,13.89045 L19.7526,10.3422 C20.55675,9.543675 21,8.48145 21,7.35105 C21,6.2211 20.55675,5.158875 19.75215,4.3599 Z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconLink
